module.exports = __webpack_public_path__ + "img/graph-dummy-fp-overview.27e82a4c.svg";